import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class NotificationListApiService {
    private baseUrl = `${environment.apiUrl}/notification-logs`;

    constructor(private http: HttpClient) {}

    getNotificationList(): Observable<any[]> {
        return this.http.get<any[]>(this.baseUrl);
    }

    markAsRead(id: string): Observable<any> {
        return this.http.get<any>(`${this.baseUrl}/read/${id}`);
    }
}
